var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 41.3438C32.2355 41.3438 41.3438 32.2355 41.3438 21C41.3438 9.76446 32.2355 0.65625 21 0.65625C9.76446 0.65625 0.65625 9.76446 0.65625 21C0.65625 32.2355 9.76446 41.3438 21 41.3438Z","fill":"#1877F2","key":0}),React.createElement("path",{"d":"M22.3781 30.8438V21.8531H25.3969L25.8563 18.375H22.3781V16.1438C22.3781 15.1594 22.6406 14.4375 24.0844 14.4375H25.9219V11.2875C25.5938 11.2219 24.4781 11.1562 23.2313 11.1562C20.5406 11.1562 18.7031 12.7969 18.7031 15.75V18.375H15.75V21.8531H18.7688V30.8438H22.3781Z","fill":"white","key":1})]);
}

Facebook.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
